export default __webpack_public_path__ + "static/media/pexels-rodnae-productions-7821702.a1266b6f.jpg";